import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid } from "@mui/material";

import { Form } from "@shared/components";
import { allTemplates } from "@shared/options";
import { urlToFile } from "@shared/utils";

export function ModuleForm() {
  const translate = useTranslate();
  const { watch, setValue } = useFormContext();

  const selectedPredefined = watch("predefined")

  const uniqueCategories = Array.from(
    new Set(allTemplates.map((item) => item.category))
  ).map((category) => ({
    label: category,
    value: category,
  }));

  useEffect(() => {
    if (selectedPredefined !== undefined && selectedPredefined !== null) {
      const selectedTemplate = allTemplates[selectedPredefined];

      if (selectedTemplate) {
        setValue("icon", selectedTemplate.image, { shouldDirty: true });

        urlToFile(selectedTemplate.image, selectedTemplate.title)
          .then(file => {
            setValue("icon", file, { shouldDirty: true });
          })

        setValue("title", selectedTemplate.title);
        setValue("section_title", selectedTemplate.category);
        setValue("url", selectedTemplate.url || "");
      }
    }
  }, [selectedPredefined, setValue]);

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="predefined"
          label={translate("agreement_modules_admin.fields.predefined")}
          options={allTemplates.map((item, index) => ({
            label: item.title,
            value: index,
          }))}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="section_title"
          label={translate("agreement_modules_admin.fields.section_title")}
          options={uniqueCategories}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="title"
          label={translate("agreement_modules_admin.fields.title")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.SinglePhotoPicker
          name="icon"
          label={translate("agreement_modules_admin.fields.icon")}
          shape="square"
          size={150}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="url"
          label={translate("agreement_modules_admin.fields.url")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="is_external"
          label={translate("agreement_modules_admin.fields.is_external")}
          defaultChecked={false}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="allow_edit"
          label={translate("agreement_modules_admin.fields.allow_edit")}
          defaultChecked={false}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("agreement_modules_admin.fields.active")}
          defaultChecked={true}
          required
        />
      </Grid>
    </Grid>
  );
}
